module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.9860/js/img/CommerceHub_Icon.svg"